import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { formsActions } from '../forms-actions';
import { map } from 'rxjs';
import { StoreCollectionFormInitializationStatus } from '../forms-state';

@Injectable()
export class FormsStatusEffects {
  private actions$ = inject(Actions);
  public setFormStatusAfterInitialization$ = createEffect(() => this.actions$.pipe(
    ofType(formsActions.formFinishedLoading),
    map(props => formsActions.formInitializationStatusChanged(
      {formId: props.formId, status: StoreCollectionFormInitializationStatus.Initialized}
    ))
  ));
}